import { type FC } from "react";
import { useTranslation } from "react-i18next";
import type { Voivodeship } from "@/types/Voivodeship";
import { useMultiStepForm } from "@/hooks";
import { addToDataGrid } from "@/utils/data";
import { Step4 } from "@/components/FormSteps";
import { DataGrid, type DataGridItem } from "./DataGrid";
import SummaryStep from "./SummaryStep";

export const SummaryStep4: FC = () => {
  const { t } = useTranslation();
  const { form } = useMultiStepForm();
  const step4 = form.getValues().step4;

  const data: DataGridItem[] = [
    ...addToDataGrid(
      "import-power",
      t("summary.importPower"),
      step4.importPower ? t("MWValue", { value: step4.importPower }) : "-",
    ),
    ...addToDataGrid(
      "export-power",
      t("summary.exportPower"),
      step4.exportPower ? t("MWValue", { value: step4.exportPower }) : "-",
    ),
    {
      id: "can-sell",
      label: t("summary.canSellEnergy"),
      value: step4.canSellEnergy === "true" ? t("yes") : t("no"),
    },
    {
      id: "pv-installation",
      label: t("summary.pvInstallation"),
      value: step4.hasPvInstallation === "true" ? t("yes") : t("no"),
    },
    ...addToDataGrid(
      "installation-power",
      t("summary.installationPower"),
      t("MWValue", { value: step4.installationPower ?? "-" }),
      step4.hasPvInstallation === "true",
    ),
    ...addToDataGrid(
      "inverter-power",
      t("summary.inverterPower"),
      t("MWValue", { value: step4.inverterPower ?? "-" }),
      step4.hasPvInstallation === "true" && Boolean(step4.inverterPower),
    ),
    ...addToDataGrid(
      "voivodeship",
      t("step4.voivodeship"),
      step4.voivodeship ? t(`voivodeships.${step4.voivodeship as Voivodeship}`) : "-",
      step4.hasPvInstallation === "true",
    ),
  ];

  return (
    <SummaryStep
      stepTitle="step4"
      stepKey="step4"
      cardTitle={`4. ${t("stepper.step4")}`}
      cardContent={<DataGrid items={data} dataTest="summary-step4-data-grid" />}
      formComponent={Step4}
    />
  );
};
